/**
 * Coups de pouce — Attendu 638 « Identifier la structure d'un motif évolutif ».
 *
 * Une entrée par `generator_key` (cf. gen_638.js). Contrat d'une entrée :
 *   pages : 2 pages MAXIMUM, chacune { titre, lignes?, svg? }.
 *
 * Règle absolue : l'aide porte sur d'AUTRES valeurs que celles que le
 * générateur peut tirer (ici : rang 4, jamais tiré — le générateur commence à
 * 5 — et départ 7 avec ajout 6, hors contextes géométriques).
 * Emphase : **texte** (rendu en gras, pas de HTML brut). Pas de tiret cadratin.
 */

// ── Suite additive : compter les SAUTS (rang − 1), l'erreur n° 1 ──
// Animation SMIL au clic (id cp638play1), une lecture puis gel : les valeurs
// se remplissent de gauche à droite, les 3 sauts s'encadrent, la formule
// 7 + 3 × 6 = 25 s'écrit, les conclusions restent affichées.
const SVG_SUITE_ADD_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 212" role="img"
     aria-label="Animation : une suite part de 7 et ajoute 6 à chaque rang. Les rangs 2, 3 et 4 se remplissent : 13, 19, 25. Du rang 1 au rang 4 il y a 3 sauts, donc 7 plus 3 fois 6 égale 25">
  <g id="cp638play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- rangs -->
  <text x="48" y="52" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">rang 1</text>
  <text x="138" y="52" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">rang 2</text>
  <text x="228" y="52" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">rang 3</text>
  <text x="318" y="52" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">rang 4</text>
  <!-- cases -->
  <rect x="20" y="60" width="56" height="36" rx="6" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <rect x="110" y="60" width="56" height="36" rx="6" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <rect x="200" y="60" width="56" height="36" rx="6" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <rect x="290" y="60" width="56" height="36" rx="6" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <!-- valeurs -->
  <text x="48" y="84" font-size="16" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">7</text>
  <text x="138" y="84" font-size="16" fill="#94a3b8" text-anchor="middle" font-family="system-ui,sans-serif">?<animate attributeName="opacity" values="1;1;0;0" keyTimes="0;0.14;0.2;1" dur="7s" begin="cp638play1.click" fill="freeze"/></text>
  <text x="138" y="84" font-size="16" font-weight="700" fill="#0f172a" opacity="0" text-anchor="middle" font-family="system-ui,sans-serif">13<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.14;0.2;1" dur="7s" begin="cp638play1.click" fill="freeze"/></text>
  <text x="228" y="84" font-size="16" fill="#94a3b8" text-anchor="middle" font-family="system-ui,sans-serif">?<animate attributeName="opacity" values="1;1;0;0" keyTimes="0;0.26;0.32;1" dur="7s" begin="cp638play1.click" fill="freeze"/></text>
  <text x="228" y="84" font-size="16" font-weight="700" fill="#0f172a" opacity="0" text-anchor="middle" font-family="system-ui,sans-serif">19<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.26;0.32;1" dur="7s" begin="cp638play1.click" fill="freeze"/></text>
  <text x="318" y="84" font-size="16" fill="#94a3b8" text-anchor="middle" font-family="system-ui,sans-serif">?<animate attributeName="opacity" values="1;1;0;0" keyTimes="0;0.38;0.44;1" dur="7s" begin="cp638play1.click" fill="freeze"/></text>
  <text x="318" y="84" font-size="16" font-weight="700" fill="#0f172a" opacity="0" text-anchor="middle" font-family="system-ui,sans-serif">25<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.38;0.44;1" dur="7s" begin="cp638play1.click" fill="freeze"/></text>
  <!-- flèches + 6 -->
  <line x1="80" y1="78" x2="104" y2="78" stroke="#64748b" stroke-width="1.5"/>
  <path d="M104 78 L98 74 M104 78 L98 82" fill="none" stroke="#64748b" stroke-width="1.5"/>
  <text x="92" y="70" font-size="13" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">+ 6</text>
  <line x1="170" y1="78" x2="194" y2="78" stroke="#64748b" stroke-width="1.5"/>
  <path d="M194 78 L188 74 M194 78 L188 82" fill="none" stroke="#64748b" stroke-width="1.5"/>
  <text x="182" y="70" font-size="13" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">+ 6</text>
  <line x1="260" y1="78" x2="284" y2="78" stroke="#64748b" stroke-width="1.5"/>
  <path d="M284 78 L278 74 M284 78 L278 82" fill="none" stroke="#64748b" stroke-width="1.5"/>
  <text x="272" y="70" font-size="13" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">+ 6</text>
  <!-- accolade des 3 sauts -->
  <path d="M80 104 L80 110 L284 110 L284 104" fill="none" stroke="#dc2626" stroke-width="1.5" opacity="0">
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.5;0.58;1" dur="7s" begin="cp638play1.click" fill="freeze"/>
  </path>
  <text x="182" y="128" font-size="13" font-weight="700" fill="#dc2626" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">3 sauts (4 − 1)<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.5;0.58;1" dur="7s" begin="cp638play1.click" fill="freeze"/></text>
  <!-- formule -->
  <text x="180" y="154" font-size="15" font-weight="700" fill="#0f172a" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">7 + 3 × 6 = 25<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.62;0.72;1" dur="7s" begin="cp638play1.click" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="30" y="168" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="46" y="176" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Du rang 1 au rang 4, on fait 4 − 1 = 3 sauts.</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.78;0.86;1" dur="7s" begin="cp638play1.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="30" y="190" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="46" y="198" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Le terme au rang 4 vaut 7 + 3 × 6 = 25.</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.84;0.92;1" dur="7s" begin="cp638play1.click" fill="freeze"/>
  </g>
</svg>`.trim();

// ── Suite multiplicative : mêmes sauts, mais des × (id cp638play2) ──
// Départ 4, × 3, rang 4 : le générateur ne tire jamais le rang 4 avec le
// facteur 3 (ses rangs vont de 5 à 8), aucune collision possible.
const SVG_SUITE_MULT_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 212" role="img"
     aria-label="Animation : une suite part de 4 et multiplie par 3 à chaque rang. Les rangs 2, 3 et 4 se remplissent : 12, 36, 108. Du rang 1 au rang 4 il y a 3 sauts, donc 4 fois 3 fois 3 fois 3 égale 108">
  <g id="cp638play2" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- rangs -->
  <text x="48" y="52" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">rang 1</text>
  <text x="138" y="52" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">rang 2</text>
  <text x="228" y="52" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">rang 3</text>
  <text x="318" y="52" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">rang 4</text>
  <!-- cases -->
  <rect x="20" y="60" width="56" height="36" rx="6" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <rect x="110" y="60" width="56" height="36" rx="6" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <rect x="200" y="60" width="56" height="36" rx="6" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <rect x="290" y="60" width="56" height="36" rx="6" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <!-- valeurs -->
  <text x="48" y="84" font-size="16" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">4</text>
  <text x="138" y="84" font-size="16" fill="#94a3b8" text-anchor="middle" font-family="system-ui,sans-serif">?<animate attributeName="opacity" values="1;1;0;0" keyTimes="0;0.14;0.2;1" dur="7s" begin="cp638play2.click" fill="freeze"/></text>
  <text x="138" y="84" font-size="16" font-weight="700" fill="#0f172a" opacity="0" text-anchor="middle" font-family="system-ui,sans-serif">12<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.14;0.2;1" dur="7s" begin="cp638play2.click" fill="freeze"/></text>
  <text x="228" y="84" font-size="16" fill="#94a3b8" text-anchor="middle" font-family="system-ui,sans-serif">?<animate attributeName="opacity" values="1;1;0;0" keyTimes="0;0.26;0.32;1" dur="7s" begin="cp638play2.click" fill="freeze"/></text>
  <text x="228" y="84" font-size="16" font-weight="700" fill="#0f172a" opacity="0" text-anchor="middle" font-family="system-ui,sans-serif">36<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.26;0.32;1" dur="7s" begin="cp638play2.click" fill="freeze"/></text>
  <text x="318" y="84" font-size="16" fill="#94a3b8" text-anchor="middle" font-family="system-ui,sans-serif">?<animate attributeName="opacity" values="1;1;0;0" keyTimes="0;0.38;0.44;1" dur="7s" begin="cp638play2.click" fill="freeze"/></text>
  <text x="318" y="84" font-size="16" font-weight="700" fill="#0f172a" opacity="0" text-anchor="middle" font-family="system-ui,sans-serif">108<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.38;0.44;1" dur="7s" begin="cp638play2.click" fill="freeze"/></text>
  <!-- flèches × 3 -->
  <line x1="80" y1="78" x2="104" y2="78" stroke="#64748b" stroke-width="1.5"/>
  <path d="M104 78 L98 74 M104 78 L98 82" fill="none" stroke="#64748b" stroke-width="1.5"/>
  <text x="92" y="70" font-size="13" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">× 3</text>
  <line x1="170" y1="78" x2="194" y2="78" stroke="#64748b" stroke-width="1.5"/>
  <path d="M194 78 L188 74 M194 78 L188 82" fill="none" stroke="#64748b" stroke-width="1.5"/>
  <text x="182" y="70" font-size="13" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">× 3</text>
  <line x1="260" y1="78" x2="284" y2="78" stroke="#64748b" stroke-width="1.5"/>
  <path d="M284 78 L278 74 M284 78 L278 82" fill="none" stroke="#64748b" stroke-width="1.5"/>
  <text x="272" y="70" font-size="13" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">× 3</text>
  <!-- accolade des 3 sauts -->
  <path d="M80 104 L80 110 L284 110 L284 104" fill="none" stroke="#dc2626" stroke-width="1.5" opacity="0">
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.5;0.58;1" dur="7s" begin="cp638play2.click" fill="freeze"/>
  </path>
  <text x="182" y="128" font-size="13" font-weight="700" fill="#dc2626" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">3 sauts (4 − 1)<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.5;0.58;1" dur="7s" begin="cp638play2.click" fill="freeze"/></text>
  <!-- formule -->
  <text x="180" y="154" font-size="15" font-weight="700" fill="#0f172a" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">4 × 3 × 3 × 3 = 108<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.62;0.72;1" dur="7s" begin="cp638play2.click" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="30" y="168" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="46" y="176" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Du rang 1 au rang 4, on fait 4 − 1 = 3 sauts.</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.78;0.86;1" dur="7s" begin="cp638play2.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="30" y="190" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="46" y="198" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Le terme au rang 4 vaut 4 × 3 × 3 × 3 = 108.</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.84;0.92;1" dur="7s" begin="cp638play2.click" fill="freeze"/>
  </g>
</svg>`.trim();

// ── Suite logique : animation du pas (id cp638play3) ──
// 2,3 ; 2,6 ; 2,9 ; 3,2 : les arcs « + 0,3 » révèlent le pas, puis on
// l'ajoute au dernier terme.
const SVG_SUITE_DEC_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 184" role="img"
     aria-label="La suite 2,3 ; 2,6 ; 2,9 ; 3,2. Entre chaque paire de termes voisins, un arc vert indique plus 0,3 : le pas de la suite. Puis 3,2 plus 0,3 égale 3,5 : le terme suivant">
  <g id="cp638play3" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- la suite -->
  <g font-size="16" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif" text-anchor="middle" opacity="0">
    <text x="60" y="78">2,3</text><text x="88" y="78" fill="#64748b">;</text>
    <text x="116" y="78">2,6</text><text x="144" y="78" fill="#64748b">;</text>
    <text x="172" y="78">2,9</text><text x="200" y="78" fill="#64748b">;</text>
    <text x="228" y="78">3,2</text><text x="256" y="78" fill="#64748b">;</text>
    <text x="284" y="78" fill="#94a3b8">…</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp638play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp638play3.click+0.3s" fill="freeze"/>
  </g>
  <!-- les arcs du pas -->
  <g opacity="0">
    <path d="M60,60 Q88,42 116,60" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <text x="88" y="44" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">+ 0,3</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp638play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp638play3.click+1.6s" fill="freeze"/>
  </g>
  <g opacity="0">
    <path d="M116,60 Q144,42 172,60" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <text x="144" y="44" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">+ 0,3</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp638play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp638play3.click+2.4s" fill="freeze"/>
  </g>
  <g opacity="0">
    <path d="M172,60 Q200,42 228,60" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <text x="200" y="44" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">+ 0,3</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp638play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp638play3.click+3.2s" fill="freeze"/>
  </g>
  <!-- le terme suivant -->
  <text x="172" y="122" font-size="15" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">3,2 + 0,3 = 3,5<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp638play3.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp638play3.click+4.6s" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="148" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="156" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Trouve le pas : la différence entre deux voisins.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp638play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp638play3.click+5.8s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="170" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="178" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Ajoute ce même pas au dernier terme.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp638play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp638play3.click+6.4s" fill="freeze"/>
  </g>
</svg>`.trim();

// Entrée commune aux formats transplantés du gen 609 (revue 2026-08-27) :
// l'aide dédiée aux suites de décimaux voyage avec sa carte.
const CP_SUITE_DEC = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_SUITE_DEC_ANIM,
        },
    ],
};

// Entrée commune aux formats de l'exercice suite_multiplicative.
const CP_MULTI = {
    pages: [
        {
            titre: 'Un exemple',
            lignes: [
                'Une suite commence à **4**. À chaque étape, on multiplie par **3**. Quel est le terme au **rang 4** ?',
            ],
            svg: SVG_SUITE_MULT_ANIM,
        },
    ],
};

// Entrée commune aux formats de l'exercice suite_additive.
const CP_ADDITIVE = {
    pages: [
        {
            titre: 'Un exemple',
            lignes: [
                'Une suite commence à **7**. À chaque étape, on ajoute **6**. Quel est le terme au **rang 4** ?',
            ],
            svg: SVG_SUITE_ADD_ANIM,
        },
    ],
};

const CP_638 = {
    suite_additive_qcm: CP_ADDITIVE,
    suite_additive_saisie: CP_ADDITIVE,
    suite_additive_texte_trou: CP_ADDITIVE,
    suite_multiplicative_qcm: CP_MULTI,
    suite_multiplicative_saisie: CP_MULTI,
    suite_multiplicative_texte_trou: CP_MULTI,
    // Carte « suite logique de décimaux » transplantée du 609 avec son aide
    // dédiée (animation du pas, revue 2026-08-27).
    suite_logique_qcm_unique:        CP_SUITE_DEC,
    suite_logique_texte:             CP_SUITE_DEC,
    suite_logique_texte_trou_saisie: CP_SUITE_DEC,
};

export default CP_638;
